<template>
  <div id="app" class="app-container">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
  </div>
</template>

<style>

/* Desktop: badge visible, leyenda oculta */
.grecaptcha-badge {
  visibility: visible !important;
  opacity: 1 !important;
}

/* En pantallas pequeñas ocultamos el badge */
@media (max-width: 768px) {
  .grecaptcha-badge {
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  /* Mostramos la leyenda solo en mobile */
  .recaptcha-legal {
    display: block !important;
  }
}

/* Desktop: ocultamos la leyenda */
.recaptcha-legal {
  display: none;
  font-size: 0.75rem;
  opacity: 0.75;
  text-align: center;
  margin-top: 12px;
  color: #dcdcdc;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 5.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 5;
}

#app {
  font-family: Ubuntu, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}


.description {
  font-family: "Ubuntu-Light";
  font-size: 16px;
}

.bg-gradient-pill {
  background: linear-gradient(90deg, #a8ff78, #78ffd6);
  color: #0b1822 !important;
  border: 0;
}

.fontsatoshi {
  font-family: 'Satoshi', sans-serif !important;
}

/* ===== Layout & Responsive ===== */
.landing-wrap {
  color: var(--text-strong);
  background: linear-gradient(180deg, #0b1822, #0e2533 40%, #0a2a43);
  overflow-x: clip;
}

.bloque {
  margin-top: -30px !important;
}

.heading-glow {
  color: #fff;
  text-shadow: 0 0 10px rgba(0, 229, 255, .45), 0 0 2px rgba(255, 255, 255, .25);
  font-weight: 800;
}

@keyframes electric-border {

  0%,
  100% {
    background-position: 0% 50%
  }

  50% {
    background-position: 100% 50%
  }
}

.card-elevate {
  transition: transform .25s, box-shadow .25s, border-color .25s;
}

.card-elevate:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 36px rgba(0, 229, 255, .20);
  border-color: rgba(0, 229, 255, .35);
}



/* ===== Chips & Features ===== */

.feature-item {
  display: flex;
  align-items: flex-start;
}

.icon-wrapper {
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.check-icon {
  width: 1rem;
  height: 1rem;
  color: #a8ff78;
}

.feature-text {
  line-height: 1.4;
}

/* ===== Separador ondulado ===== */
.wave-sep svg {
  display: block;
  width: 100%;
  height: 120px;
}

.wave-sep path {
  fill: #0e2533;
}

/* ===== Modal & CTA ===== */
.modal-tech {
  background: rgba(12, 22, 32, .96);
  border-radius: 1rem;
  color: #f8f9fa;
  border: 1px solid rgba(0, 229, 255, .30);
  box-shadow: 0 0 28px rgba(0, 229, 255, .25);
}

.modal-title {
  color: var(--tech-cyan);
  font-weight: 700;
}


/* ===== Buttons ===== */
.btn-primary {
  background: linear-gradient(90deg, #00c6ff, #0072ff);
  border: 0;
  border-radius: 999px;
  padding: .65rem 1.25rem;
}

.btn-primary:hover {
  filter: brightness(1.06);
}

.view-details {
  color: #ffffffcb !important;
  text-decoration: none;
}

.view-details:hover {
  color: #00c6ff !important;
  text-decoration: underline;
}


@keyframes float {

  0%,
  100% {
    transform: translateY(0)
  }

  50% {
    transform: translateY(16px)
  }
}

/* ===== Accessibility ===== */
:focus-visible {
  outline: 3px solid var(--tech-cyan);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}

/* ===== Responsive ===== */
@media (min-width:1025px) and (max-width:1440px) {
  .textdescription {
    font-size: 1.3rem;
  }

  .textdescription2 {
    font-size: 1.3rem;
  }
}

@media (min-width:769px) and (max-width:1024px) {
  .textdescription {
    font-size: 1rem;
  }

  .textdescription2 {
    font-size: 1.5rem;
  }
}

@media (min-width:577px) and (max-width:768px) {
  .device-mockup {
    width: 220px;
    height: 150px;
  }

  .hero-title {
    font-size: 1.9rem;
  }

  .hero-tech {
    min-height: auto;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .my-4 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .textdescription {
    font-size: 1.6rem;
  }

  .textdescription2 {
    font-size: 1.8rem;
  }
}

@media (min-width:426px) and (max-width:576px) {
  .textdescription {
    font-size: 1.2rem;
  }

  .textdescription2 {
    font-size: 1.3rem;
  }
}

@media (min-width:321px) and (max-width:425px) {
  .textdescription {
    font-size: 1rem;
  }

  .textdescription2 {
    font-size: 1rem;
  }
}

@media (min-width:300px) and (max-width:320px) {
  .textdescription {
    font-size: 1rem;
  }

  .textdescription2 {
    font-size: 1rem;
  }
}

</style>
